import { apiSlice } from '../../api/apiSlice';

export interface MachineData {
  customer: string;
  id: number;
  mac_address: string;
  machine_model: string;
  name: string;
  partner: string;
  serial_number: string;
  type: string;
  uuid: string;
}

export interface ProvisionLinkRequest {
  customer_group_uuid: string;
  link_name: string;
  managed_machines: string[];
  serial_number: string;
}

export interface SetWifiRequest {
  customer_group_uuid: string;
  link_name: string;
  password: string;
  serial_number: string;
  ssid: string;
}

export const thirdPartyIntegrationsApiSlice = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    getMachines: builder.query<MachineData[], { serial_filter?: string }>({
      query: ({ serial_filter }) => ({
        params: serial_filter ? { serial_filter } : {},
        url: '/ops/third_party_integrations/machines',
      }),
    }),
    provisionLink: builder.mutation<
      void,
      { apiHost: string; data: ProvisionLinkRequest }
    >({
      query: ({ apiHost, data }) => ({
        body: data,
        method: 'POST',
        url: `${apiHost}/v1/iot-provisioning-service/anylink/provision/link`,
      }),
    }),
    setWifi: builder.mutation<void, { apiHost: string; data: SetWifiRequest }>({
      query: ({ apiHost, data }) => ({
        body: data,
        method: 'POST',
        url: `${apiHost}/v1/iot-provisioning-service/anylink/provision/wifi`,
      }),
    }),
  }),
  overrideExisting: false,
});

export const {
  useGetMachinesQuery,
  useLazyGetMachinesQuery,
  useProvisionLinkMutation,
  useSetWifiMutation,
} = thirdPartyIntegrationsApiSlice;
